// "Exemple și inițiative" community cards become a Swiper carousel on
// mobile only — same technique as participation-swiper.js (Swiper is
// instantiated/destroyed across the 767px breakpoint so the desktop
// flex-wrap layout in _community-grid.scss is never touched).
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';

$(function () {
    const el = document.querySelector('[data-community-swiper]');

    if (!el) {
        return;
    }

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    let swiper = null;

    const enable = () => {
        if (swiper) {
            return;
        }

        swiper = new Swiper(el, {
            modules: [Navigation, FreeMode],
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            navigation: {
                nextEl: '[data-community-next]',
                prevEl: '[data-community-prev]',
            },
        });
    };

    const disable = () => {
        if (!swiper) {
            return;
        }

        swiper.destroy(true, true);
        swiper = null;
    };

    const sync = () => (mediaQuery.matches ? enable() : disable());

    sync();
    mediaQuery.addEventListener('change', sync);
});
